import { MouseEvent, forwardRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import {
  Button,
  ButtonProps,
  Tooltip,
  Typography,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { KeyboardShortcut } from '../KeyboardShortcut';
import { useMultiStepDialogContext } from '../MultiStepDialog/context';

const styles = createStyles({
  root: {},
});

type PrevProps = WithStyles<typeof styles> & ButtonProps;

const Prev = forwardRef<HTMLButtonElement, PrevProps>((props, ref) => {
  const { classes, className, onClick, children = 'Back', ...rest } = props;
  const { onPrevStep } = useMultiStepDialogContext();

  useHotkeys('meta+backspace', () => onPrevStep(), {
    enabled: !rest.disabled,
    // We want to allow the user to go to previous step even if they have
    // focus on an input field.
    enableOnFormTags: true,
  });

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    if (!event.defaultPrevented) {
      onPrevStep();
    }
  };

  return (
    <Tooltip
      title={
        <Typography variant="body2" style={{ padding: 2 }}>
          Go back to previous step <KeyboardShortcut hotkey="meta+backspace" />
        </Typography>
      }
    >
      <Button
        ref={ref}
        className={classNames(classes.root, className)}
        onClick={handleClick}
        data-track-source-anchor="6636213952;prev-button" {...rest}
      >
        {children}
      </Button>
    </Tooltip>
  );
});
Prev.displayName = 'Prev';

export default withStyles(styles)(Prev);
